import { gql } from "@apollo/client";

export default gql`
query GetSurveysForProblems($survey_language: String, $trial_type: String, $survey_type: String, $completed_dateNotNull: Boolean) {
  surveys(trial_type: $trial_type, survey_language:$survey_language, survey_type: $survey_type, completed_dateNotNull: $completed_dateNotNull) {
    title
    completed_date
    user {
      user_name
    }
    problems {
      id
      page_number
      problem_type
      content
      created_date
      updated_date
      status
      response
    }
    pc_edge
    pc_chrome
    pc_firefox
    pc_other
    mac_safari
    mac_chrome
    mac_firefox
    mac_other
    ios_tablet
    ios_smartphone
    ios_safari
    ios_edge
    ios_chrome
    ios_firefox
    ios_other
    android_tablet
    android_smartphone
    android_edge
    android_chrome
    android_firefox
    android_other
    vpn
  }
}
`